export const REVERSE_CALL_DIAL_TIMEOUT_MS = 20_000

export function reverseCallNumberWaitTimedOut(startedAtMs: number, nowMs: number): boolean {
    return nowMs - startedAtMs >= REVERSE_CALL_DIAL_TIMEOUT_MS
}
